import React from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

import ErrorBoundary from "./components/ErrorBoundary";

// O ThemeProvider do produto vive em `context/DarkMode` e é montado dentro de
// `routes/index.js`. Não crie um segundo tema aqui: o provider mais interno
// vence e o de fora vira código morto (era o caso até a Fase 1 do redesign).
const App = () => (
  <ErrorBoundary>
    <Routes />
  </ErrorBoundary>
);

export default App;
